// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Template_dropDown_compendium {
  height: 32px;
  border-radius: 5px;
  position: relative;
  top: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
}

::ng-deep.Template_dropDown_compendium .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 11px;
}

::ng-deep.Template_dropDown_compendium .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Template_dropDown_compendium .mat-form-field-label-wrapper {
  top: -1px !important;
}

.Template_dropDown_default {
  height: 32px;
  border-radius: 5px;
  position: relative;
  top: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
}

::ng-deep.Template_dropDown_default .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 11px;
}

::ng-deep.Template_dropDown_default .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 0% !important;
  margin: 0% !important;
}

::ng-deep.Template_dropDown_default .mat-form-field-label-wrapper {
  top: -16% !important;
}

.fonts_size_com {
  font-size: 11px !important;
}

::ng-deep.compendium_modal .autocomplete-container .suggestions-container ul li a {
  padding: 14px 15px;
  display: block;
  text-decoration: none;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.87);
  font-size: 11px !important;
}

.compendium_cast {
  font-size: 11px !important;
}

.compendium_casetype {
  width: 100%;
  padding-inline: 10px;
}

::ng-deep.compendium_casetype .mat-standard-chip {
  font-size: 11px;
  margin: 0px;
  height: 23px;
  padding-inline: 5px;
  min-height: unset;
  margin-right: 7px !important;
}

::ng-deep.compendium_casetype .mat-form-field-wrapper {
  padding: 0px !important;
}

::ng-deep.compendium_casetype .mat-form-field-infix {
  padding: 4px !important;
  padding-bottom: 6px !important;
  padding-top: 0px !important;
}

::ng-deep.compendium_casetype.mat-form-field-appearance-outline .mat-form-field-flex {
  padding-inline: 5px !important;
}

.case_input_compendium::placeholder {
  font-weight: 700 !important;
  font-size: 11px;
}

::ng-deep.compen_radio .mat-radio-container {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}

::ng-deep.compen_radio .mat-radio-outer-circle {
  box-sizing: border-box;
  height: 15px;
  left: 0;
  position: absolute;
  top: 0;
  transition: border-color ease 280ms;
  width: 15px;
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
}

::ng-deep.compen_radio .mat-radio-inner-circle {
  border-radius: 50%;
  box-sizing: border-box;
  height: 15px;
  left: 0;
  position: absolute;
  top: 0;
  transition: transform ease 280ms, background-color ease 280ms;
  width: 15px;
  transform: scale(0.001);
}

::ng-deep.compen_radio .mat-radio-checked .mat-radio-inner-circle {
  transform: scale(0.5);
}

.date_control_stylecomp {
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2), 0 2px 5px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  width: 78%;
  float: left;
  min-height: 8vh !important;
  max-height: 8vh !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  background-color: white !important;
  top: 10px;
}

::ng-deep.customstylecomp .mat-mdc-form-field {
  width: 100% !important;
  position: relative !important;
  bottom: 8px !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: white !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay {
  background-color: white !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex {
  min-height: 38px !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  max-height: 250px !important;
  padding-bottom: 0px !important;
  min-height: 42px !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-input-element {
  font-size: 12px !important;
  width: 150px;
  flex: 1 0 150px !important;
  margin-left: 4px;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip {
  height: 24px !important;
  float: left !important;
  margin-inline: 1px !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mdc-evolution-chip__text-label {
  font-size: 12px !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper {
  background-color: white !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay {
  background-color: white !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  display: flex !important;
  padding-top: 5px !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-input-element {
  font-size: 12px !important;
  width: 150px !important;
  flex: 1 0 150px !important;
  margin-left: 4px;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip {
  height: 24px !important;
  float: left !important;
  margin-inline: 1px !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mdc-evolution-chip__text-label {
  font-size: 12px !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-focused .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
::ng-deep.customstylecomp .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/compendium/compendium.component.scss"],"names":[],"mappings":"AAMA;EACE,YAAA;EACA,kBAAA;EAEA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AANF;;AASA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AANF;;AAQA;EACE,WAAA;EACA,UAAA;AALF;;AAOA;EACE,oBAAA;AAJF;;AAMA;EACE,YAAA;EACA,kBAAA;EAEA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAJF;;AAMA;EACE,sBAAA;EACA,qBAAA;AAHF;;AAKA;EACE,oBAAA;AAFF;;AAKA;EACE,0BAAA;AAFF;;AAKA;EACE,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,0BAAA;EACA,0BAAA;AAFF;;AAIA;EACE,0BAAA;AADF;;AAGA;EACE,WAAA;EAAY,oBAAA;AACd;;AACA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,4BAAA;AAEF;;AAAA;EACE,uBAAA;AAGF;;AADA;EACE,uBAAA;EACA,8BAAA;EACA,2BAAA;AAIF;;AACA;EACE,8BAAA;AAEF;;AAAA;EACE,2BAAA;EACA,eAAA;AAGF;;AAAA;EACE,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAGF;;AADA;EACE,sBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,mCAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAIF;;AAFA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,6DAAA;EACA,WAAA;EACA,uBAAA;AAKF;;AAHA;EACE,qBAAA;AAMF;;AAGA;EACE,gHAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,kCAAA;EACA,SAAA;AAAF;;AAEA;EACE,sBAAA;EACA,6BAAA;EACA,sBAAA;AACF;AAAE;EACE,kCAAA;AAEJ;AADI;EACE,wBAAA;AAGN;AADI;EACE,kCAAA;AAGN;AADI;EACE,2BAAA;AAGN;AAFM;EAEA,4BAAA;EACA,8BAAA;EACA,2BAAA;AAGN;AAFM;EACE,0BAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;AAIR;AAFM;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;AAIR;AAHQ;EACE,0BAAA;AAKV;AAEI;EACA,kCAAA;AAAJ;AACI;EACE,wBAAA;AACN;AACI;EACE,kCAAA;AACN;AACI;EACE,wBAAA;EACA,2BAAA;AACN;AAAM;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AAER;AAAM;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;AAER;AADQ;EACE,0BAAA;AAGV;AAEI;EACE,wBAAA;AAAN;AAGE;EACE,wBAAA;AADJ","sourcesContent":["// ::ng-deep .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {\r\n//   border-color: #ff4081;\r\n// }\r\n// ::ng-deep .mat-radio-button.mat-accent .mat-radio-inner-circle, .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple), .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple, .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple {\r\n//   background-color: #ff4081;\r\n// }\r\n.Template_dropDown_compendium{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  // padding-inline: 1%;\r\n  position: relative;\r\n  top: 1%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n  // margin-block: 1%;\r\n}\r\n::ng-deep.Template_dropDown_compendium  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 11px;\r\n}\r\n::ng-deep.Template_dropDown_compendium .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Template_dropDown_compendium .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n.Template_dropDown_default{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  // padding-inline: 1%;\r\n  position: relative;\r\n  top: 1%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n  // margin-block: 1%;\r\n}\r\n::ng-deep.Template_dropDown_default  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 11px;\r\n}\r\n::ng-deep.Template_dropDown_default .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 0% !important;\r\n  margin: 0% !important;\r\n}\r\n::ng-deep.Template_dropDown_default .mat-form-field-label-wrapper{\r\n  top:-16% !important;\r\n}\r\n\r\n.fonts_size_com{\r\n  font-size:11px !important;\r\n}\r\n\r\n::ng-deep.compendium_modal .autocomplete-container .suggestions-container ul li a {\r\n  padding: 14px 15px;\r\n  display: block;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  font-size: 11px !important;\r\n}\r\n.compendium_cast{\r\n  font-size:11px !important;\r\n}\r\n.compendium_casetype{\r\n  width: 100%;padding-inline: 10px;\r\n}\r\n::ng-deep.compendium_casetype .mat-standard-chip{\r\n  font-size: 11px;\r\n  margin: 0px;\r\n  height: 23px;\r\n  padding-inline: 5px;\r\n  min-height:unset;\r\n  margin-right: 7px !important;\r\n}\r\n::ng-deep.compendium_casetype .mat-form-field-wrapper{\r\n  padding: 0px !important;\r\n}\r\n::ng-deep.compendium_casetype  .mat-form-field-infix{\r\n  padding: 4px !important;\r\n  padding-bottom: 6px !important;\r\n  padding-top: 0px !important;\r\n  // padding-left: 0% !important;\r\n}\r\n\r\n\r\n::ng-deep.compendium_casetype.mat-form-field-appearance-outline .mat-form-field-flex{\r\n  padding-inline: 5px !important;\r\n}\r\n.case_input_compendium::placeholder{\r\n  font-weight: 700 !important;\r\n  font-size: 11px;\r\n}\r\n\r\n::ng-deep.compen_radio .mat-radio-container {\r\n  box-sizing: border-box;\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 15px;\r\n  height: 15px;\r\n  flex-shrink: 0;\r\n}\r\n::ng-deep.compen_radio .mat-radio-outer-circle {\r\n  box-sizing: border-box;\r\n  height: 15px;\r\n  left: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  transition: border-color ease 280ms;\r\n  width: 15px;\r\n  border-width: 2px;\r\n  border-style: solid;\r\n  border-radius: 50%;\r\n}\r\n::ng-deep.compen_radio .mat-radio-inner-circle {\r\n  border-radius: 50%;\r\n  box-sizing: border-box;\r\n  height: 15px;\r\n  left: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  transition: transform ease 280ms,background-color ease 280ms;\r\n  width: 15px;\r\n  transform: scale(.001);\r\n}\r\n::ng-deep.compen_radio .mat-radio-checked .mat-radio-inner-circle {\r\n  transform: scale(.5);\r\n}\r\n\r\n// ::ng-deep.matchipstyles.caseht .mat-mdc-text-field-wrapper{\r\n//   height: 35px !important;\r\n//   .mdc-notched-outline{\r\n//     height: 35px !important;\r\n//   }\r\n// }\r\n.date_control_stylecomp {\r\n  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2), 0 2px 5px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);\r\n  border-radius: 5px;\r\n  width: 78%;\r\n  float: left;\r\n  min-height: 8vh !important;\r\n  max-height: 8vh !important;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  background-color: white !important; \r\n  top: 10px;\r\n}\r\n::ng-deep.customstylecomp .mat-mdc-form-field{\r\n  width: 100% !important;\r\n  position: relative !important;\r\n  bottom: 8px !important;\r\n  .mat-mdc-text-field-wrapper{\r\n    background-color: white !important;\r\n    .mdc-line-ripple{\r\n      display: none !important;\r\n    }\r\n    .mat-mdc-form-field-focus-overlay{\r\n      background-color: white !important;\r\n    }\r\n    .mat-mdc-form-field-flex{ \r\n      min-height: 38px !important;\r\n      .mat-mdc-form-field-infix{\r\n      // padding-top: 0px  !important;\r\n      max-height: 250px !important;\r\n      padding-bottom: 0px !important;\r\n      min-height: 42px !important;\r\n      .mat-mdc-input-element{\r\n        font-size: 12px !important;\r\n        width: 150px ;\r\n        flex: 1 0 150px !important;\r\n        margin-left: 4px;\r\n      }\r\n      .mat-mdc-chip{\r\n        height: 24px !important;\r\n        float: left !important;\r\n        margin-inline: 1px !important;\r\n        .mdc-evolution-chip__text-label{\r\n          font-size: 12px !important;\r\n        }\r\n      }\r\n    }\r\n    }\r\n  }\r\n  .mat-focused {\r\n    .mat-mdc-text-field-wrapper{\r\n    background-color: white !important;\r\n    .mdc-line-ripple{\r\n      display: none !important;\r\n    }\r\n    .mat-mdc-form-field-focus-overlay{\r\n      background-color: white !important;\r\n    }\r\n    .mat-mdc-form-field-flex .mat-mdc-form-field-infix{\r\n      display: flex !important;\r\n      padding-top: 5px  !important;\r\n      .mat-mdc-input-element{\r\n        font-size: 12px !important;\r\n        width: 150px !important;\r\n        flex: 1 0 150px !important;\r\n        margin-left: 4px;\r\n      }\r\n      .mat-mdc-chip{\r\n        height: 24px !important;\r\n        float: left !important;\r\n        margin-inline: 1px !important;\r\n        .mdc-evolution-chip__text-label{\r\n          font-size: 12px !important;\r\n        }\r\n      }\r\n    }\r\n    }\r\n    .mat-mdc-form-field-subscript-wrapper{\r\n      display: none !important;\r\n    }\r\n  }\r\n  .mat-mdc-form-field-subscript-wrapper{\r\n    display: none !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
